import { useState } from 'react';
import { RootState } from '../../../../iwProvider/configureStore';
import { connect } from 'react-redux';
import styles from './PaymentPlans.module.css';
import cn from 'classnames';
import { PaymentPlanCard } from '../paymentPlanCard/PaymentPlanCard';
import PlanButton from '../PlanButton/PlanButton';
import { Plan, PlanTypes } from '../Dashboard.types';

const mapStateToProps = (state: RootState) => state.iwocapayDashboard;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const PaymentsPlans = ({
    endedPayments,
    ongoingPaymentPlans,
    capturedPlans,
    cancelledPayments,
    selectPaymentPlan,
    selectedPlan
}: PropsFromRedux & {
    selectPaymentPlan: (plan: Plan, isActive: boolean) => void;
}) => {
    const defaultOption = () => {
        if (capturedPlans.length > 0) return 'pending';
        if (ongoingPaymentPlans.length > 0) return 'active';
        if (endedPayments.length > 0 || cancelledPayments.length > 0)
            return 'completed';

        return 'active';
    };
    const [selectedPlanType, setSelectedPlanType] =
        useState<PlanTypes>(defaultOption());

    const getPaymentPlans = () => {
        switch (selectedPlanType) {
            case 'active':
                return ongoingPaymentPlans;
            case 'pending':
                return capturedPlans;
            case 'completed':
                return [...endedPayments, ...cancelledPayments];
        }
    };

    if (
        !endedPayments.length &&
        !ongoingPaymentPlans.length &&
        !capturedPlans.length &&
        !cancelledPayments.length
    )
        return null;

    return (
        <>
            <span className={styles.selectPaymentPlan}>
                {capturedPlans.length > 0 && (
                    <button
                        onClick={() => setSelectedPlanType('pending')}
                        className={cn(styles.paymentPlanButton, {
                            [styles.activeButton]:
                                selectedPlanType === 'pending'
                        })}
                        data-tracking-id="active-plans-toggled"
                    >
                        Pending
                    </button>
                )}
                <button
                    onClick={() => setSelectedPlanType('active')}
                    className={cn(styles.paymentPlanButton, {
                        [styles.activeButton]: selectedPlanType === 'active'
                    })}
                    data-tracking-id="active-plans-toggled"
                >
                    Active
                </button>
                <button
                    onClick={() => setSelectedPlanType('completed')}
                    className={cn(styles.paymentPlanButton, {
                        [styles.activeButton]: selectedPlanType === 'completed'
                    })}
                    data-tracking-id="completed-plans-toggled"
                >
                    Completed
                </button>
            </span>
            <h2 className={styles.paymentPlanTitle}>
                Your {selectedPlanType.toLowerCase()} payment plans
            </h2>
            <ul>
                {getPaymentPlans().map((paymentPlan) => (
                    <li
                        key={paymentPlan.pay_link_id}
                        className={styles.paymentCard}
                    >
                        <PlanButton
                            selectedPlanId={selectedPlan?.pay_link_id!}
                            selectPaymentPlan={selectPaymentPlan}
                            paymentPlan={paymentPlan}
                            status={paymentPlan.status}
                        >
                            <PaymentPlanCard
                                created={paymentPlan.payLink.created}
                                funded_at={paymentPlan.payLink.funded_at}
                                reference={paymentPlan.payLink.reference}
                                sellerName={
                                    paymentPlan.payLink.seller_trading_name
                                }
                                amount={paymentPlan.payLink.amount}
                                status={paymentPlan.status}
                            />
                        </PlanButton>
                    </li>
                ))}
            </ul>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(PaymentsPlans);
